var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0V2H0V6H2V32C2 33.0609 2.42143 34.0783 3.17157 34.8284C3.92172 35.5786 4.93913 36 6 36H26C27.0609 36 28.0783 35.5786 28.8284 34.8284C29.5786 34.0783 30 33.0609 30 32V6H32V2H22V0H10ZM6 6H26V32H6V6ZM10 10V28H14V10H10ZM18 10V28H22V10H18Z",
    fill: "#5D5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.e112ff8628ea06ddfe276dfecd18e307.svg";
export { ForwardRef as ReactComponent };